import scrollLock from 'scroll-lock';
import View from '../view/view';
import mitt from 'mitt';

class Controller {
	constructor() {
		this.events = mitt();

		this.touch = "ontouchend" in document;

		this.passiveEventsSupported = (() => {
			// passive event listeners support test from MDN
			let result = false;
			try {
				window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
					get: () => result = true
				}));
			} catch (err) {}
			return result;
		})();

		this.mobileNavData = [];

		// Текущее состояние шторки ЛК (для тоггла по кнопке-триггеру).
		// Держим в синхроне: любое закрытие шторки (кнопка, оверлей, ресайз)
		// эмитит lk-nav-close — сбрасываем флаг, чтобы следующий клик открывал.
		this.lkNavOpen = false;
		this.events.on('lk-nav-close', () => { this.lkNavOpen = false; });
		this.events.on('lk-nav-open', () => { this.lkNavOpen = true; });

		document.addEventListener('keydown', (e) => {
			if (e.keyCode === 27) {
				this.closeAll();
			}
		});

		document.querySelector('.js-overlay').addEventListener('click', () => {
			this.closeAll();
		});

		View.initAllGlobal();
		View.initAllLocal(document.body);
	}

	lockScrolling() {
		const $fillGapElement = document.querySelector('.page-header-wrap');
		if ($fillGapElement) {
			scrollLock.addFillGapTarget($fillGapElement);
		}
		scrollLock.enablePageScroll();
		scrollLock.disablePageScroll(document.querySelectorAll('.modal__surface'));
	}

	unlockScrolling() {
		scrollLock.enablePageScroll(document.querySelectorAll('.modal__surface'));
	}

	openMobileNav() {
		this.events.emit('mobile-nav-open');
	}
	
	updateForm() {
		this.events.emit('update-form');
	}
	
	updateUsers() {
		this.events.emit('update-users');
	}

	closeMobileNav() {
		this.events.emit('mobile-nav-close');
	}

	updateMobileNav(data) {
		this.mobileNavData.push(data);
		this.events.emit('mobile-nav-updated', this.mobileNavData);
	}

	openLkMobileMenu() {
		this.lkNavOpen = true;
		this.events.emit('lk-nav-open');
		scrollLock.enablePageScroll();
		scrollLock.disablePageScroll(document.querySelectorAll('.internal-nav__box-inner'));

	}

	closeLkMobileMenu() {
		this.lkNavOpen = false;
		this.events.emit('lk-nav-close');
		scrollLock.enablePageScroll(document.querySelectorAll('.internal-nav__box-inner'));
	}

	// Повторный клик по той же кнопке-триггеру закрывает шторку.
	toggleLkMobileMenu() {
		if (this.lkNavOpen) {
			this.closeLkMobileMenu();
		} else {
			this.openLkMobileMenu();
		}
	}
	
	openCatalogAside() {
		document.body.classList.add('state--catalog-aside-open');
	}

	closeCatalogAside() {
		document.body.classList.remove('state--catalog-aside-open');
	}

	openSearchSmall() {
		this.events.emit('search-small-open');
	}

	closeSearchSmall() {
		this.events.emit('search-small-close');
	}

	emitCustomEvent(eventname, response) {
		this.events.emit(eventname, response);
	}

	openModal(options) {
		if (window.modalController) {
			window.modalController.open(options);
		}
	}

	closeModal() {
		if (window.modalController) {
			window.modalController.close();
		}
	}

	closeAllModals() {
		if (window.modalController) {
			window.modalController.closeAll();
		}
	}

	closeAll() {
		this.closeMobileNav();
		this.closeCatalogAside();
		this.closeMobileNav();
		this.closeSearchSmall();
		this.closeAllModals();
	}

	updateModelSource(dataType) {
		this.events.emit('update-model-source', dataType);
	}

	addNotification(data) {
		this.events.emit('add-notification', data);
	}
}

export default new Controller();